import { UniversalIrEngine } from './framework/UniversalIrEngine';
// LG Model LAEB015-GN
export class LgLed extends UniversalIrEngine {
    constructor() {
        super(...arguments);
        this.irRepeat = 1;
        this.irConfig = {
            type: 'display',
            operations: {
                powerToggle: `,1,37878,${this.irRepeat},1,342,170,22,64,22,64,22,64,22,64,22,21,22,21,22,64,22,21,22,21,22,64,22,21,22,21,22,64,22,21,22,64,22,21,22,21,22,64,22,21,22,21,22,21,22,21,22,21,22,21,22,64,22,21,22,64,22,64,22,64,22,64,22,64,22,63,22,1484,342,85,22,3624,342,85,22,3624,342,85,22,3624,342,85,22,3624,342,85,22,3623,342,85,22,3623,342,85,22,3623,342,85,22,3623,342,85,22,3623`,
            },
            videoInputs: {
                hdmi1: `,1,38000,${this.irRepeat},69,343,172,21,22,21,22,21,65,21,22,21,22,21,22,21,22,21,22,21,65,21,65,21,22,21,65,21,65,21,65,21,65,21,65,21,22,21,65,21,65,21,65,21,22,21,22,21,65,21,65,21,65,21,22,21,22,21,22,21,65,21,65,21,22,21,22,21,1673,343,86,21,3732`,
            },
        };
    }
}
LgLed.key = '-MtAVI8zmYFUVJWh2UKV';
